export default {
  title_one: 'Toimitustilastoja päivitetään kampanjalle "{{title}}"',
  title_other: 'Toimitustilastoja päivitetään {{count}} kampanjalle',
  subtitle_pending:
    'Apple ja Google vahvistavat kuitit noin {{minutes}} min {{seconds}} s kuluttua (noin {{time}}). Tilastot päivittyvät automaattisesti.',
  subtitle_ready: 'Kuittien pitäisi olla saapuneet. Päivitä sivu nähdäksesi uusimmat toimitusluvut.',
};
